// Module
var code = "<div class=\"adviser-dropdown\"> <span class=\"clip-select clip-select-caret\"> <select id=\"{{::vm.id}}\" name=\"{{::vm.name}}\" class=\"form-control\" ng-model=\"vm.selectedValue\" ng-options=\"option[vm.valueField] as option[vm.displayField] for option in vm.options\"> </select> </span> </div> ";
// Exports
module.exports = code;